// const BUILDER_KEY = "BUILDER_KEY";
//
// export const setBuilder =
//  <T>(v: T): void => localStorage.setItem(BUILDER_KEY, JSON.stringify(v));
//
// export const getBuilder = <T>(): T | null => {
//   const value = localStorage.getItem(BUILDER_KEY);
//
//   return value ? JSON.parse(value) : null;
// };
//
// export const unsetBuilder = (): void => localStorage.removeItem(BUILDER_KEY);
import { ProjectIsGPT } from "./project"
export const checkBuilderType = function (): string {
    
    if(ProjectIsGPT()) {
        return 'GPT'
    }

    return 'BASE'
}
